import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdfr2bj9ks: FaireProductEntity = {
  token: "p_cdfr2bj9ks",
  type: "product",
  name: "18K Gold Plated Stainless Steel Hollow Hoop Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/c6c40f66d276a564f799639916086f42580d1ecd7d3ec9f387d27ff73c03663e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3584c1e754c58d767c4c67f3eeacec0f3798371951ebb69af0615f18b87d1fb.jpeg",
    "https://cdn.faire.com/fastly/4a8411e84a797851e4122cc6bcd0f635bde8df76bde65fced0eb1bea6df8db69.jpeg",
    "https://cdn.faire.com/fastly/9da282a2220b536866d5ca675f9d2d17b326294fb685f1d3ada7ca161dfb36ed.jpeg",
  ],
  priceDollars: 6.58,
  description:
    "Material: stainless steel，18k gold plated\nSize：1.91inch*1.99inch\n\nProcess: Vacuum electroplating and manual polishing\nSurface : High Polish \n\n ★Made of high quality stainless steel，Lead-free，Harmless to Human Body. ★Perfect jewelry gifts \n                              \n",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:17.164Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
